<template>
  <div class="database-left-menu">
    <div class="database-left-menu-item" v-track="{ functionName: `${trackPrefix}${item.name}`}" @click.stop="switchIdSecond(item)"
         v-for="item in currentMenu"
         :class="isCurSecond(item) ? 'cur':''"
         :key="item && item.id">
      <div class="database-left-menu-item-title">
        <span :class="{ 'text-ellipsis': !wrapText }">{{ item && item.name }}</span>
        <van-icon name="arrow-down" v-if="isCurSecond(item)" class="arrow-icon"/>
        <van-icon name="arrow" v-else class="arrow-icon"/>
      </div>
      <div class="database-left-menu-item-sub-menu" v-if="isCurSecond(item)">
        <div class="database-left-menu-item-sub-menu-item" v-track="{ functionName: `${trackPrefix}${subItem.name}`}"
             @click.stop="switchIdThird(subItem)"
             :class="[isCurThird(subItem) ? 'cur':'', { 'item-wrap': wrapText }]"
             v-for="subItem in item.children" :key="subItem.id">
          <div class="database-left-menu-item-sub-menu-item-title">
            <span :class="{ 'text-ellipsis-single': !wrapText }">{{ subItem && subItem.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuList: {
      type: Array,
      default: () => []
    },
    courseCategoryIdFirst: {
      type: String,
      default: ''
    },
    courseCategoryIdSecond: {
      type: String,
      default: ''
    },
    courseCategoryIdThird: {
      type: String,
      default: ''
    },
    wrapText: {
      type: Boolean,
      default: false
    },
    trackPrefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentMenu() {
      const item = this.menuList.find(item => item.id === this.courseCategoryIdFirst)
      return (item && item.children && item.children.length > 0) ? item.children : []
    },
    isCurSecond() {
      return (item) => item.id === this.courseCategoryIdSecond
    },
    isCurThird() {
      return (item) => item.id === this.courseCategoryIdThird
    }
  },
  data() {
    return {}
  },
  watch: {
    currentMenu: {
      immediate: true,
      handler(list) {
        if (list.length > 0 && !this.courseCategoryIdSecond) {
          this.$emit('update:courseCategoryIdSecond', list[0].id)
          this.$emit('defaultList')
        }
      }
    }
  },
  methods: {
    switchIdSecond(item) {
      if (this.courseCategoryIdSecond === item.id) {
        this.$emit('update:courseCategoryIdSecond', '')
        this.$emit('update:courseCategoryIdThird', '')
        this.$emit('defaultList')
        return
      }
      this.$emit('update:courseCategoryIdSecond', item.id)
      this.$emit('update:courseCategoryIdThird', '')
      this.$emit('defaultList')
    },
    switchIdThird(item) {
      if (this.courseCategoryIdThird === item.id) {
        this.$emit('update:courseCategoryIdThird', '')
        this.$emit('defaultList')
        return
      }
      this.$emit('update:courseCategoryIdThird', item.id)
      this.$emit('defaultList')
    }
  }
}
</script>

<style scoped lang="less">
.database-left-menu {

  .database-left-menu-item {
    cursor: pointer;
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .database-left-menu-item-title {
      display: flex;
      align-items: flex-start;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: #393A3B;
      padding-left: 10px;
      box-sizing: border-box;

      span {
        flex: 1;
        width: 0;
        margin-right: 5px;
      }

      .text-ellipsis {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }

      .arrow-icon {
        margin-top: 4px;
      }
    }

    .database-left-menu-item-sub-menu {
      background: rgba(223, 224, 229, .4);

      .database-left-menu-item-sub-menu-item {
        height: 30px;
        display: flex;
        align-items: center;
        margin-left: 10px;
        box-sizing: border-box;
        border-left: 2px solid #E7E7EB;
        cursor: pointer;

        &.item-wrap {
          height: auto;
          min-height: 30px;
          align-items: flex-start;

          .database-left-menu-item-sub-menu-item-title {
            padding: 6px 5px 6px 8px;
            align-items: flex-start;
          }
        }

        .database-left-menu-item-sub-menu-item-title {
          padding-left: 8px;
          padding-right: 5px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          width: 100%;

          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #2B2B2B;
            flex: 1;
            width: 0;
          }

          .text-ellipsis-single {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .text-wrap {
            word-break: break-all;
            white-space: normal;
          }
        }

        &.cur {
          .database-left-menu-item-sub-menu-item-title {
            span {
              font-weight: bold;
              font-size: 12px;
              color: #EB1700;
            }
          }
        }
      }
    }

    &.cur {
      .database-left-menu-item-title {
        span {
          font-weight: 600;
          font-size: 14px;
          color: #EB1700;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/database/modules/DatabaseLeftMenu.vue